module.exports = __webpack_public_path__ + "static/Andrew-2678a0a0c7362e6cbb9d7544d14c32ab.jpg";